'use strict'

module.exports = process.nextTick
